
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"#363636","stroke-width":"0px"},attrs:{"d":"m47.19,3c7.61,0,13.81,4.85,13.81,10.82v36.36c0,3.06-1.58,5.3-2.92,6.64-2.65,2.66-6.62,4.18-10.89,4.18h-29.53c-8.08,0-14.66-5.17-14.66-11.52V13.84c0-5.98,6.2-10.84,13.83-10.84h30.36Zm0-3h-30.36C7.54,0,0,6.2,0,13.84v35.64c0,8.02,7.9,14.52,17.66,14.52h29.53c9.29,0,16.83-6.18,16.81-13.82V13.82c0-7.64-7.52-13.82-16.81-13.82Zm-21.63,18.66c4.05-1.71,8.53-1.72,12.61-.04.77.32,1.64-.05,1.96-.81.32-.77-.05-1.64-.81-1.96-4.82-1.99-10.12-1.97-14.92.05-.76.32-1.12,1.2-.8,1.96.24.57.8.92,1.38.92.19,0,.39-.04.58-.12Zm6.31,30.11c-1.56,0-3.12-.26-4.63-.79-3.55-1.24-6.4-3.78-8.03-7.16-1.63-3.38-1.85-7.2-.62-10.74,1.24-3.55,3.78-6.4,7.16-8.03,3.38-1.63,7.2-1.85,10.74-.62,3.55,1.24,6.4,3.78,8.03,7.16,1.63,3.38,1.85,7.2.62,10.74-1.24,3.55-3.78,6.4-7.16,8.03-1.94.94-4.02,1.41-6.11,1.41Zm-.02-25.13c-1.64,0-3.28.37-4.8,1.11-2.66,1.29-4.66,3.53-5.63,6.32-.97,2.79-.8,5.79.49,8.45,1.29,2.66,3.53,4.66,6.32,5.63,2.79.97,5.79.8,8.45-.49s4.66-3.53,5.63-6.32c.97-2.79.8-5.79-.49-8.45s-3.53-4.66-6.32-5.63c-1.19-.41-2.42-.62-3.65-.62Zm1.3,11.83l3.96-6.63c.42-.71.19-1.63-.52-2.06-.71-.42-1.63-.19-2.06.52l-2.54,4.24-2.1-4.35c-.36-.75-1.26-1.06-2-.7-.75.36-1.06,1.26-.7,2l3.32,6.86c.24.5.73.82,1.28.85h.07c.53,0,1.02-.28,1.29-.73Z"}})])
          )
        }
      }
    